import { SvgStarFill } from '@common/icon';

import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { WEL_MARKET_ROUTES } from '@/constants/routes';
import { formatPrice } from '@/utils/formatPrice';

interface SearchMarketCardProps {
  productId?: string;
  imageUrl?: string;
  productName?: string;
  region?: string;
  originalPrice?: number;
  expectedFinalPrice?: number;
  discountRate?: number;
  rating?: number;
  reviewCount?: number;
}

export const SearchMarketCard = ({
  productId,
  imageUrl,
  productName,
  region,
  originalPrice,
  expectedFinalPrice,
  discountRate,
  rating,
  reviewCount,
}: SearchMarketCardProps) => {
  const regularPrice = originalPrice ?? 0;
  const finalPrice = expectedFinalPrice ?? regularPrice;
  const hasDiscount = finalPrice !== regularPrice;
  const detailHref = productId
    ? WEL_MARKET_ROUTES.PRODUCT_DETAIL.pathname({ productNumber: productId })
    : '#';

  return (
    <article className="flex flex-col gap-8">
      <CustomLink
        href={detailHref}
        aria-label={`${productName ?? ''} 상세 페이지로 이동`}
        className="relative aspect-square w-full overflow-hidden rounded-xlarge"
      >
        {imageUrl ? (
          <Image
            src={imageUrl}
            alt={productName ?? '상품 이미지'}
            fill
            className="object-cover"
          />
        ) : (
          <div className="size-full bg-Gray-100" />
        )}
      </CustomLink>

      <div className="flex flex-col gap-8">
        {region ? (
          <p className="font-600 text-Gray-600 typo-body4">{region}</p>
        ) : null}

        {productName ? (
          <CustomLink
            href={detailHref}
            className="line-clamp-2 font-500 text-Gray-800 typo-body3"
          >
            {productName}
          </CustomLink>
        ) : null}

        <div className="flex flex-col gap-2">
          {hasDiscount ? (
            <span className="font-400 text-Gray-550 line-through typo-body4">
              {formatPrice(regularPrice)}
            </span>
          ) : null}
          <div className="flex flex-wrap items-baseline gap-x-4 gap-y-2">
            {hasDiscount && discountRate && discountRate > 0 ? (
              <span className="font-700 text-R-400 typo-body2 mobile-tablet:typo-body3">
                {discountRate}%
              </span>
            ) : null}
            <span className="font-700 text-Gray-black typo-body2 mobile-tablet:typo-body3">
              {formatPrice(finalPrice)}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <SvgStarFill className="size-16 text-Y-550" />
          <div className="flex items-center gap-2">
            <span className="font-700 text-Gray-600 typo-body3 mobile-tablet:typo-body4">
              {rating ?? 0}
            </span>
            <span className="font-400 text-Gray-600 typo-body3 mobile-tablet:typo-body4">
              ({reviewCount ?? 0})
            </span>
          </div>
        </div>
      </div>
    </article>
  );
};
